import { useNavigation } from "@react-navigation/core";
import logo from "../../../assets/logo_cut.png";
import mestrado from "../../../assets/mestrado.png";
import { Center, Button, Image, Text, VStack, Link } from "native-base";
import { Platform } from "react-native";

type Props = {};

export function Home({}: Props) {
  const navigation = useNavigation();

  const handleClickStart = () => {
    navigation.navigate("SelectionPage");
  };

  return (
    <Center p={10} flex={1} bgColor="white">
      <VStack space={4}>
        <Image
          source={logo}
          alt="logo"
          width={600}
          height={100}
          resizeMode="contain"
        />

        <Text
          fontSize="2xl"
          textAlign="center"
          fontWeight="bold"
          color="#f4545c"
        >
          Direitos das pacientes com câncer de mama
        </Text>
        <Center mt={4} mb={2}>
          <Image
            source={mestrado}
            alt="logo mestrado"
            width={500}
            height={100}
            resizeMode="contain"
          />
        </Center>

        <Text color="#e8af9d" bold fontSize="md" textAlign="center">
          Carolina Alves Martins Guerra
        </Text>
        <Text color="#e8af9d" bold fontSize="md" textAlign="center">
          Daniela Francescato Veiga
        </Text>
        <Text color="#e8af9d" bold fontSize="md" textAlign="center">
          Evelyne Borges de Mattos Andrade
        </Text>

        <Button
          onPress={handleClickStart}
          bg="#f4545c"
          size="lg"
          mt="10"
          _text={{ fontWeight: "bold", color: "white", fontSize: "lg" }}
        >
          Começar
        </Button>

        <Text fontSize="sm" color="gray.500" mt="20" textAlign="justify">
          Aplicativo com objetivo de informar e orientar as pacientes com câncer
          de mama sobre seus direitos e como buscá-los
        </Text>

        {Platform.OS === "web" && (
          <Button
            onPress={() => navigation.navigate("PoliticaTermos")}
            size="lg"
            variant="ghost"
          >
            Política de Privacidade e Termos de Uso
          </Button>
        )}
      </VStack>
    </Center>
  );
}
